module.exports = __webpack_public_path__ + "img/711StoreMarkerSelect.a398672.svg";